/**
 * Phase 7.2 — Inventory review API client.
 *
 * Wraps the Phase 7.2 admin endpoints:
 *   GET    /api/inventory/canonical-types
 *   POST   /api/inventory/canonical-types
 *   DELETE /api/inventory/canonical-types/{name}
 *   GET    /api/inventory/needs-review
 *   POST   /api/inventory/reclassify
 *   GET    /api/inventory/movements/{id}
 *
 * Mirrors the patterns of `src/api/inventory.js` (axios instance + thin
 * methods returning `{data}` shaped responses).
 */
import { api } from "./client";

const inventoryReview = {
  // ── Canonical types CRUD ──────────────────────────────────────────────
  listCanonicalTypes: () => api.get("/inventory/canonical-types"),
  createCanonicalType: ({ name, display_name, stock_sign }) =>
    api.post("/inventory/canonical-types", { name, display_name, stock_sign }),
  deleteCanonicalType: (name) =>
    api.delete(`/inventory/canonical-types/${encodeURIComponent(name)}`),

  // ── Needs-review list (extended in Phase 7.2 with id + filters) ──────
  listNeedsReview: ({
    page = 1,
    page_size = 25,
    canonical_type = null,
    source = null,
    search = null,
  } = {}) => {
    const params = { page, page_size };
    if (canonical_type) params.canonical_type = canonical_type;
    if (source) params.source = source;
    if (search && search.trim()) params.search = search.trim();
    return api.get("/inventory/needs-review", { params });
  },

  // ── Bulk reclassification ────────────────────────────────────────────
  reclassify: ({ movement_ids, new_canonical_type, reason = null }) =>
    api.post("/inventory/reclassify", {
      movement_ids,
      new_canonical_type,
      reason: reason && reason.trim() ? reason.trim() : null,
    }),

  // ── Single movement detail (with full history) ───────────────────────
  getMovement: (movementId) =>
    api.get(`/inventory/movements/${encodeURIComponent(movementId)}`),
};

export default inventoryReview;
